import React, { useMemo, useState } from 'react';
import {
  Container,
  Title,
  Team,
  TeamWrapper,
  Versus,
  ChartArea,
  ChartContainer,
  ChartDivider,
  ChartHeader,
} from './styled';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import SportsTeamLogo from 'components/teamLogo';
import SingleBarChart from './SingleBarChart';
import { _COMPARISON_CHART_INIT } from '../store/constants';

const TeamGameStat = observer(({ data, gameData }) => {
  if (data.loading) {
    return null;
  } else {
    // const {} = gameData;
    const homeSeasonRecord =
      (gameData.detail.getTeamSeasonRecordData && gameData.detail.getTeamSeasonRecordData.home) || null;
    const awaySeasonRecord =
      (gameData.detail.getTeamSeasonRecordData && gameData.detail.getTeamSeasonRecordData.away) || null;
    const { home, away } = data.teamGameStat;

    return (
      <Container>
        <Title>경기 기록</Title>
        <TeamWrapper>
          <Team>
            <SportsTeamLogo imgSize={'70'} imgUrl={home.imgPath} isLazy={true} />
            <h3>{home.name}</h3>
            {homeSeasonRecord && (
              <p>
                {homeSeasonRecord.ranking}위 {homeSeasonRecord.winCount}승 {homeSeasonRecord.defeatCount}패
              </p>
            )}
          </Team>
          <Versus>
            <span>VS</span>
          </Versus>
          <Team>
            <SportsTeamLogo imgSize={'70'} imgUrl={away.imgPath} isLazy={true} />
            <h3>{away.name}</h3>
            {awaySeasonRecord && (
              <p>
                {awaySeasonRecord.ranking}위 {awaySeasonRecord.winCount}승 {awaySeasonRecord.defeatCount}패
              </p>
            )}
          </Team>
        </TeamWrapper>
        <ChartContainer>
          {Object.keys(_COMPARISON_CHART_INIT).map((key, idx) => {
            return (
              <li key={_COMPARISON_CHART_INIT[key].key}>
                {!data.comparisonChart[key].visible ? (
                  ''
                ) : (
                  <ChartArea>
                    <SingleBarChart
                      value={data.comparisonChart[key].home.p}
                      active={data.comparisonChart[key].visible && data.comparisonChart[key].home.active}
                      location='left'
                      text={data.comparisonChart[key].home.v}
                    />
                    <ChartHeader>
                      <span>{_COMPARISON_CHART_INIT[key].name}</span>
                    </ChartHeader>
                    <ChartDivider />
                    <SingleBarChart
                      value={data.comparisonChart[key].away.p}
                      active={data.comparisonChart[key].visible && data.comparisonChart[key].away.active}
                      location='right'
                      text={data.comparisonChart[key].away.v}
                    />
                  </ChartArea>
                )}
              </li>
            );
          })}
        </ChartContainer>
      </Container>
    );
  }
});

export default TeamGameStat;
